import {createSSRApp} from "vue";
import App from "./App.vue";
import 'uno.css';
import store from './store';
import {uTools} from '@/libs';
import {prototypeInterceptor, requestInterceptor} from './interceptors';

uni.$onLaunched = new Promise((resolve) => {
    uni.$isResolve = resolve;
});

export function createApp() {
    const app = createSSRApp(App);

    uni.$c = {};
    app.use(uTools);
    uni.isInited = 'padding'; // 初始化标识
    uni.isLoggedIn = false; // 登录标识

    app.use(store);
    app.use(prototypeInterceptor);
    app.use(requestInterceptor);

    return {
        app,
    };
}
